<template>
  <div>
    <v-card flat class="pa-4">
      <h4 class="title mb-4">Информация о проекте</h4>
      <LogotypeUpdateComponent class="d-block" :project="project"/>
      <div class="mt-4">
        <b class="field-title">Заказчик</b>
        <p class="field-description">Организация или лицо, для которого реализуется проект</p>
        <v-text-field class="field-control"
                      v-model="project.customer"
                      :readonly="readOnly"
                      autocomplete="off"
                      outlined
                      placeholder="Сургутский государственный университет"
        />
      </div>
      <div>
        <b class="field-title">Тип проекта</b>
        <p class="field-description">Категория проекта в зависимости от его содержания, формата и т.д</p>
        <v-autocomplete class="field-control" v-model="project.project_type_id"
                        :items="$store.state.projects.project_types"
                        :readonly="readOnly"
                        auto-select-first
                        autocomplete="off" item-text="name" item-value="id"
                        outlined/>
      </div>
      <div>
        <b class="field-title">Цель проекта</b>
        <p class="field-description">Что будет достигнуто? Когда? Как? Как вы измерите уровень достижения
          результата? </p>
        <v-textarea class="field-control"
                    v-model="project.participation_purpose" :readonly="readOnly" outlined/>
      </div>
      <div>
        <b class="field-title">Название проекта</b>
        <p class="field-description">Отражает основную идею проекта </p>
        <v-text-field class="field-control" v-model="project.title"
                      :readonly="readOnly" outlined/>
      </div>
      <div>
        <b class="field-title">Задача</b>
        <p class="field-description">Конкретное действие или комплекс действий, которые необходимо выполнить для достижения цели проекта</p>
        <v-textarea class="field-control"
                    v-model="project.task" :readonly="readOnly" outlined/>
      </div>
      <div>
        <b class="field-title">Проблема проекта</b>
        <p class="field-description">Сложности, затруднения, препятствия, которые будут преодолены с помощью
          проекта </p>
        <v-textarea class="field-control" v-model="project.problem"
                    :readonly="readOnly" outlined/>
      </div>
      <div>
        <b class="field-title">Планируемый результат</b>
        <p class="field-description">Какой конкретный итог планируется получить по завершении проекта</p>
        <v-textarea class="field-control" v-model="project.result" :readonly="readOnly" outlined/>
      </div>
      <div>
        <b class="field-title">Требуемые материальные ресурсы</b>
        <p class="field-description">Материалы, оборудование, техника и другие ресурсы, необходимые для реализации проекта</p>
        <v-textarea class="field-control" v-model="project.resources" :readonly="readOnly" outlined/>
      </div>
      <div>
        <b class="field-title">Тип продукта</b>
        <p class="field-description">Форма итогового продукта, который будет создан в рамках проекта</p>
        <v-combobox class="field-control"
                    :readonly="readOnly"
                    outlined
                    :items="['изделие', 'приложение', 'мероприятие', 'модель', 'медиа ресурс']"
                    v-model="project.product_type"
        />
      </div>
      <div v-if="project.id && project.approved"
           class="passport-section">
      <div class="passport-title mb-4">
        <h4 class="title mt-2 mb-2 white--text">Паспорт проекта</h4>
      </div>
        <div>
          <b class="field-title">Сроки выполнения проекта</b>
          <p class="field-description">Сроки, в которые выполняется проект</p>
          <v-text-field placeholder="например, март 2022 - январь 2022"
                        class="field-control" v-model="project.deadlines"
                        :readonly="readOnly" outlined/>
          <EditorField :readonly="readOnly" v-model="project.relevance" placeholder="Здесь можно писать"
                       class="editorfield-control"
                       description="Описание подходов к решению проблемы в мировой повестке, российской, областной, на уровне университета"
                       label="Актуальность"/>
          <EditorField :readonly="readOnly" v-model="project.auditory" placeholder="Здесь можно писать"
                       class="editorfield-control"
                       description="Характеристики целевой аудитории (социальные, экономические, поведенческие и т.д.). Подтвердите ссылками на исследования по данной целевой аудитории, результатами собственных опросов"
                       label="Целевая аудитория"/>
          <EditorField :readonly="readOnly" v-model="project.competitors" placeholder="Здесь можно писать"
                       class="editorfield-control"
                       description="Кто еще решает данную проблему? Каковы характеристики его решения? Чем оно лучше/слабее вашего?"
                       label="Конкуренты и аналоги"/>

          <EditorField :readonly="readOnly" v-model="project.novelty" placeholder="Здесь можно писать"
                       class="editorfield-control"
                       description="Чем ваше решение принципиально отличается от аналогов и конкурентов? Преимущества вашего решения"
                       label="Новизна"/>

          <EditorField :readonly="readOnly" v-model="project.risks" placeholder="Здесь можно писать"
                       class="editorfield-control"
                       description="Внешние и внутренние риски. Их оценка и меры по предотвращению"
                       label="Риски"/>

          <EditorField :readonly="readOnly" v-model="project.product" placeholder="Здесь можно писать"
                       class="editorfield-control"
                       description="Опишите ваш продукт в виде ценностного предложения"
                       label="Результат/продукт"/>


          <EditorField :readonly="readOnly" v-model="project.measured_features" placeholder="Здесь можно писать"
                       class="editorfield-control"
                       description="Представьте не менее трех исчислимых показателей"
                       label="Ключевые характеристики продукта - Исчислимые"/>

          <EditorField :readonly="readOnly" v-model="project.not_measured_features" placeholder="Здесь можно писать"
                       class="editorfield-control"
                       description="Представьте не менее двух неисчислимых"
                       label="Ключевые характеристики продукта - Неисчислимые"/>

          <EditorField :readonly="readOnly" v-model="project.resources_and_costs" placeholder="Здесь можно писать"
                       class="editorfield-control"
                       description="Необходимые ресурсы, в том числе финансовые расходы"
                       label="Ресурсы"/>

          <EditorField :readonly="readOnly" v-model="project.incomes" placeholder="Здесь можно писать"
                       class="editorfield-control"
                       description="Источник и объемы доходов"
                       label="Доходы"/>

          <EditorField :readonly="readOnly" v-model="project.promotion_channels" placeholder="Здесь можно писать"
                       class="editorfield-control"
                       description="Один – два основных канала продвижения с учётом поведения вашей целевой аудитории. Один запасной с учетом слабых сторон основных каналов"
                       label="Каналы продвижения"/>

          <EditorField :readonly="readOnly" v-model="project.partners" placeholder="Здесь можно писать"
                       class="editorfield-control"
                       description="Партнеры, в том числе заказчик проекта"
                       label="Партнеры"/>
          <b class="field-title">Достигнутый уровень</b>
          <p class="field-description">Текущий уровень готовности продукта на данном этапе реализации проекта</p>
          <v-combobox :readonly="readOnly"
                      outlined
                      class="field-control"
                      :items="['Прототип', 'MVP', 'Готовый продукт']"
                      v-model="project.level"/>

          <b class="field-title">Этап реализации</b>
          <p class="field-description">Текущая стадия развития и продвижения проекта</p>
          <v-combobox :readonly="readOnly"
                      outlined
                      class="field-control"
                      :items="['Концепция', 'Апробирован', 'Доработан по результатам апробации', 'Подготовлен к продаже', 'Представлен на акселераторы, конкурсы, гранты']"
                      v-model="project.step"/>

          <EditorField :readonly="readOnly" v-model="project.step_description" placeholder="Здесь можно писать"
                       class="editorfield-control"
                       description="ссылки, документы, примечания"
                       label="Материалы проекта"/>
        </div>
      </div>
      <v-btn outlined rounded v-if="!readOnly" :loading="saveLoading" color="blue darken-2" dark @click="save">
        Сохранить
      </v-btn>
    </v-card>
  </div>
</template>

<script>
import LogotypeUpdateComponent from '@/components/Projects/ProjectsItem/LogotypeUpdateComponent'
import EditorField from "@/components/Projects/Utils/EditorField";

export default {
  name: 'ProjectsItemInfoComponent',
  components: {LogotypeUpdateComponent, EditorField},
  computed: {
    project() {
      return this.$store.state.projects.currentProject
    },

    readOnly() {
      return !this.$store.state.projects.currentProject.permissions.can_edit_info
    },
  },
  data() {
    return {
      saveLoading: false,
    }
  },
  methods: {
    save() {
      this.saveLoading = true
      this.$store.dispatch('updateProject', this.$store.state.projects.currentProject).then(() => {
        this.saveLoading = false
      })
    },
  },
  mounted() {
  },
}
</script>

<style scoped>
.field-title {
  font-weight: 700;
}

.field-description {
  margin-bottom: 8px;
}

.field-control {
  border-radius: 10px;
}

.editorfield-control {
  margin-bottom: 26px;
}

.passport-section {
  margin-top: 14px;
  padding-top: 20px;
  border-top: 1px solid #eaeaea;
}

.passport-title{
  background-color: #1976D2;
  border-radius: 10px;
  padding: 6px 16px;
}


</style>